'use client';

import { useMutation } from '@tanstack/react-query';
import type { Locale } from '@/lib/i18n-routes';

async function saveLanguagePreference(language: Locale): Promise<void> {
  const response = await fetch('/api/account/preferences', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ language }),
  });
  if (!response.ok) {
    throw new Error(`PUT /api/account/preferences returned ${response.status}`);
  }
}

export function useLanguagePreference() {
  return useMutation({
    mutationFn: saveLanguagePreference,
    onError: (error) => {
      console.warn('Failed to save language preference:', error);
    },
  });
}
